import React, { createContext, useState } from 'react';

export const DateContext = createContext();

const DateContextProvider = (props) => {
    const today = Date.now();
    const [currentDate, setCurrentDate] = useState(today);
    return (
        <DateContext.Provider value={{ currentDate, setCurrentDate }}>
            {props.children}
        </DateContext.Provider>
    );
};

export default DateContextProvider;
